import CustomButton from "@/components/CustomButton";
import { useAppDispatch } from "@/hooks/useAppDispatch";
import { useAppSelector } from "@/hooks/useAppSelector";
import { systemActions } from "@/redux/system/system-slice";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";

export default function Auth() {
  const navigate = useNavigate();
  const errorMsg = useAppSelector((state) => state.system.error);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (errorMsg) {
      toast.error(`${errorMsg}`, { toastId: "error" });
    }
    return () => {
      dispatch(systemActions.setError(""));
    };
  }, [errorMsg]);

  function navigateToSSO() {
    navigate("/sso");
  }

  return (
    <div
      className={`bg-[hsla(223, 28%, 97%, 1)] flex h-screen flex-col items-center justify-between`}
    >
      <CustomButton
        className={`force-case mt-32 flex h-[55px] w-[338px] items-center justify-center !rounded-lg border-none bg-[#006e34] !text-2xl !font-medium !leading-4 text-white`}
        text="Log In with Microsoft"
        onClickHandler={navigateToSSO}
      />
    </div>
  );
}
